module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9524_navy_blue.0eebd0ee.jpg";